import { format } from "date-fns";
import type { useStpStats } from "creso-core/hooks";
import { formatShort, titleCase } from "creso-core/utils";
import { StatTile } from "../../primitives";
import { StatsBar } from "./stats-bar";

export type StpStatsData = NonNullable<
  ReturnType<typeof useStpStats>["data"]
>;

export function StpStats({
  stats,
  className,
}: {
  stats?: StpStatsData;
  className?: string;
}) {
  if (!stats) return null;

  return (
    <StatsBar className={className}>
      <StatTile
        label="Monthly Transfers"
        value={
          stats.total_active_stp_amount
            ? formatShort(stats.total_active_stp_amount)
            : "-"
        }
      />
      <StatTile label="Active STPs" value={stats.active_stp_count} />
      <StatTile
        label="Total Transferred"
        value={
          stats.total_transferred_amount
            ? formatShort(stats.total_transferred_amount)
            : "-"
        }
      />
      {stats.frequencies && (
        <StatTile
          label="Frequency"
          value={stats.frequencies.map((f) => titleCase(f)).join(", ")}
        />
      )}
      {stats.next_installment_date && (
        <StatTile
          label="Next Installment"
          value={format(stats.next_installment_date, "PP")}
        />
      )}
    </StatsBar>
  );
}
